<template lang="pug">
    .post-heading
        h3.is-size-5-desktop.is-size-6-touch.is-uppercase.has-text-primary(v-if="subHeading") {{ subHeading }}
        h2.is-size-2-desktop.is-size-3-tablet.is-size-4-mobile.has-text-weight-light.is-centered(v-if="heading") {{ heading }}
</template>

<script>

// import _ from 'lodash'

export default {
    name: 'Heading',
    props: {
        heading: {
            type: String,
        },
        subHeading: {
            type: String,
        },
    },
}
</script>

<style lang="sass" scoped>

    // @import "~bulma/sass/utilities/mixins"

    .content .post-heading
        h3
            margin-top: 0
            text-align: center
            color: #000
        h4
            margin-bottom: 0
            font-weight: 900
            letter-spacing: 0

</style>
